import { Injectable } from '@angular/core';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  DatePickerOptions,
  DropdownOptions,
  FromAndToOptions,
  MessageBannerOptions
} from '@com-delta-omnichannel/mach-core-js';
import {
  createDateRange,
  createMaxSelectionRange,
  createTrigger
} from '../../utils/booking-vacation/booking-vacation.utils';

@Injectable({
  providedIn: 'root'
})
export class BookingVacationBaseAdapterService {
  errorBannerMessage = '';
  messageBannerId = 'vacation-message-banner';

  getFromAndToOptions(aem: HeaderFooterMachCore): FromAndToOptions {
    const origin = aem.header?.book?.vacations.airportPicker?.origin;
    const destination = aem.header?.book?.vacations.airportPicker?.destination;
    return {
      id: 'from-and-to',
      variant: 'default',
      originTrigger: createTrigger(origin?.fromLabel, origin?.placeHolderLabel),
      destinationTrigger: createTrigger(
        destination?.toLabel,
        destination?.placeHolderLabel
      ),
      showNativeError: false
    };
  }

  getPassengerOptions(aem: HeaderFooterMachCore): DropdownOptions {
    return {
      id: 'dropdownPassenger',
      placeholder:
        aem.header?.book?.vacations.passengers?.placeholderLabel || '',
      icon: aem.header?.book?.vacations.passengers?.icon || '',
      items: aem.header?.book?.vacations.passengers?.options?.map((option) => ({
        value: option.passengerId,
        label: option.passengerTitle,
        icon: aem.header?.book?.vacations.passengers?.icon || ''
      }))
    };
  }

  getRoomOptions(aem: HeaderFooterMachCore): DropdownOptions {
    return {
      id: 'vacationDropdownRoom',
      placeholder: aem.header?.book?.vacations.rooms?.placeholderLabel || '',
      icon: aem.header?.book.vacations?.rooms?.icon || '',
      items: aem.header?.book.vacations?.rooms?.options?.map((option) => ({
        value: option.roomsId,
        label: option.roomTitle,
        icon: aem.header?.book.vacations?.rooms?.icon || ''
      }))
    };
  }

  getDateOptions(aem: HeaderFooterMachCore): DatePickerOptions {
    const today = new Date();
    return {
      id: 'max-range-date-picker',
      title: aem.header?.book?.vacations.dates?.placeHolderLabel || '',
      selectionType: 'range',
      triggerElementId: 'max-range-date-trigger',
      dates: {
        dateRange: createDateRange(today),
        maxSelectionRange: createMaxSelectionRange(today)
      }
    };
  }

  setErrorBanner(): MessageBannerOptions {
    return {
      id: this.messageBannerId,
      type: 'error',
      isSticky: false,
      hasBar: true,
      iconSize: 'large',
      content: {
        header: {
          title: '',
          hasCloseButton: false
        },
        description: this.errorBannerMessage
      }
    };
  }
}
